import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { computed, autorun, action, observable } from 'mobx'
import { withStyles } from 'material-ui/styles'
import classnames from 'classnames'

import Button from 'material-ui/Button'
import { CircularProgress } from 'material-ui/Progress'

import styles from 'styles/components/AsyncButton'

@withStyles(styles)
@observer
export default class AsyncButton extends Component {

  static propTypes = {
    action: PropTypes.func.isRequired,
    errorLabel: PropTypes.string,
    successLabel: PropTypes.string,
    processingLabel: PropTypes.string,
    label: PropTypes.string,
    ButtonProps: PropTypes.object,
    resetTimeout: PropTypes.number
  }

  static defaultProps = {
    label: 'Сохранить',
    processingLabel: 'Сохраняем...',
    successLabel: 'Сохранено!',
    errorLabel: 'Ошибка!',
    resetTimeout: 4000
  }

  @observable isProcessing = false
  @observable isError = false
  @observable isSuccess = false

  @computed
  get showLoading() {
    return this.isProcessing
  }

  @computed
  get label() {
    const { errorLabel, successLabel, processingLabel, label } = this.props
    const { isError, isSuccess, isProcessing } = this
    return isError ? errorLabel : isSuccess ? successLabel : isProcessing ? processingLabel : label
  }

  @computed
  get disabled() {
    const { isProcessing, isError, isSuccess } = this
    return isProcessing || isError || isSuccess
  }

  @computed
  get classnames() {
    const { classes } = this.props

    return classnames({
      [classes.error]: this.isError,
      [classes.success]: this.isSuccess
    })
  }

  componentWillMount() {
    this.disposeAutorun = autorun(() => {
      if (this.isError || this.isSuccess) {
        window.setTimeout(() => { this.reset() }, this.props.resetTimeout)
      }
    })
  }

  componentWillUnmount() {
    this.disposeAutorun && this.disposeAutorun()
  }

  render() {
    const { ButtonProps, classes } = this.props

    return (
      <Button
        disabled={ this.disabled }
        onClick={ this.handleClick }
        className={ this.classnames }
        { ...ButtonProps }
      >
        <Fragment>
          { this.showLoading &&
            <CircularProgress size={15} className={ classes.loading } />
          }
          { this.label }
        </Fragment>
      </Button>
    )
  }

  @action.bound
  async handleClick() {
    let result
    this.isProcessing = true
    try {
      result = await this.props.action()
      this.isSuccess = true
    } catch (error) {
      this.isError = true
    }
    this.isProcessing = false
    return result
  }

  @action.bound
  reset() {
    this.isError = false
    this.isSuccess = false
    this.isProcessing = false
  }

}



// WEBPACK FOOTER //
// ./src/components/AsyncButton.js